import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getArts } from "../../../actions/arts";
import { getPractices } from "../../../actions/providedServices";
import { getProviders } from "../../../actions/providers";
import ProviderProvidedServiceForm from "./providerProvidedServiceForm";

const initialValues = {
  art: "",
  providerId: "",
};

const ProviderProvidedServiceFormContainer = ({ }) => {

  const dispatch = useDispatch();


  const providers = useSelector((state) => state.providers.listProviders);
  const art = useSelector((state) => state.arts);


  const loading = providers.isFetching || art.isFetching;

  useEffect(() => {
    dispatch(getProviders());
    dispatch(getArts());
  }, []);

  const handleSubmitSearch = (values) => {
    dispatch(getPractices(values.art, values.providerId));
  }

  return <ProviderProvidedServiceForm
    initialValues={initialValues}
    loading={loading}
    providers={providers.list}
    arts={art.list}
    handleSubmitSearch={handleSubmitSearch}
  />;
};

export default ProviderProvidedServiceFormContainer;